export const parseResponseError = async (
  response: Response,
): Promise<string> => {
  try {
    const body = await response.json();
    return body.message || body.error || "Unknown error";
  } catch {
    return response.statusText || "Request failed";
  }
};
